module.exports = __webpack_public_path__ + "img/Header_Celsius.3bed8ff0.png";